"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMicrophoneOffOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.microphone-off_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "microphone-off_outline_svg__transparent_box" },
            React.createElement("path", { className: "microphone-off_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "microphone-off_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "microphone-off_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M13 7.49a3.89 3.89 0 01.81-2.8A2.9 2.9 0 0116 4c2.13 0 3 1 3 3.49V8l1.9-1.9C20.39 2.76 18 2 16 2a4.76 4.76 0 00-3.6 1.27A5.69 5.69 0 0011 7.49V16l2-2zM9.09 17.91A12.24 12.24 0 019 16.5V15H7v1.5a12.28 12.28 0 00.38 3.12zM23 16.5c0 7-5.34 7.5-7 7.5a7.82 7.82 0 01-4-1.12l1.44-1.45A5.73 5.73 0 0016 22a4.87 4.87 0 003.58-1.27A5.7 5.7 0 0021 16.5v-2.68l9-9V2L2 30h2.82l5.7-5.7A9.13 9.13 0 0015 25.94V28h-4v2h10v-2h-4v-2c3.89-.37 8-3 8-9.45V15h-2zm-4 0a3.9 3.9 0 01-.81 2.81A2.94 2.94 0 0116 20a4.13 4.13 0 01-1-.13l4-4.05z" }))));
}
exports.default = SvgMicrophoneOffOutline;
//# sourceMappingURL=MicrophoneOffOutline.js.map